/**
 * Validation patterns and form constraints
 */

export const VALIDATION_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD: /^(?=.*[A-Z])(?=.*[\W])(?=.*[0-9])(?=.*[a-z]).{8,128}$/,
  POSTAL_CODE: /^[0-9]{5}$/,
  BUSINESS_ID: /^[0-9]{7}-[0-9]$/,
  FINNISH_PHONE: [/^\+358[1-9][0-9]{7,9}$/, /^0[1-9][0-9]{7,9}$/, /^[1-9][0-9]{7,9}$/],
} as const;

export const FORM_CONSTRAINTS = {
  PASSWORD: {
    MIN_LENGTH: 8,
    MAX_LENGTH: 128,
  },
  NAME: {
    MIN_LENGTH: 1,
    MAX_LENGTH: 100,
  },
  EMAIL: {
    MAX_LENGTH: 255,
  },
  PHONE: {
    MIN_LENGTH: 8,
    MAX_LENGTH: 15,
  },
  ADDRESS: {
    STREET_MAX_LENGTH: 255,
    CITY_MAX_LENGTH: 100,
    POSTAL_CODE_LENGTH: 5,
  },
} as const;
